/* Alpacas Foods — comportamentos globais do tema (vanilla JS).
   Porta: Header.tsx (sticky, menu mobile, scroll-lock). Sem React.
   Desenvolvido por Hogrid — https://hogrid.com */
(function () {
  'use strict';

  // ── Header sticky (sombra ao rolar) ──────────────────────────────────────
  var header = document.querySelector('.alp-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── Menu mobile (drawer) ──────────────────────────────────────────────────
  var menu = document.querySelector('.alp-mmenu');
  var backdrop = document.querySelector('.alp-mmenu-backdrop');
  var openBtn = document.querySelector('.alp-header__burger');
  var closeBtn = document.querySelector('.alp-mmenu__close');

  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    if (backdrop) backdrop.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) {
      menu.removeAttribute('inert');
    } else {
      menu.setAttribute('inert', '');
    }
    if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }

  if (openBtn) openBtn.addEventListener('click', function () { setMenu(true); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setMenu(false); });
  if (backdrop) backdrop.addEventListener('click', function () { setMenu(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setMenu(false);
  });

  // ── Bump do badge do carrinho quando a contagem sobe ─────────────────────
  // (atualizado pela Cart Section Rendering API — Fase 6)
  document.addEventListener('alp:cart:bump', function () {
    var el = document.querySelector('.alp-header__cart-count');
    if (!el) return;
    el.classList.remove('is-bump');
    void el.offsetWidth;
    el.classList.add('is-bump');
  });
})();
